export default __webpack_public_path__ + "static/media/home-restaurant-banner-01.ec6cce87.jpg";